import axios from 'axios';

const AGENT = 'totem';

export const getStatus = async (apiUrl, timeout = 3000) => {
    try {
        const response = await axios.get(`${apiUrl}/api/getnet/status`, {
            params: { agent: AGENT },
            timeout
        });
        return {
            agent: response.data?.ok === true,
            terminal: response.data?.open === true,
            raw: response.data
        };
    } catch (error) {
        return { agent: false, terminal: false, raw: null };
    }
};

export const cancelSale = async (apiUrl, timeout = 20000) => {
    const response = await axios.post(`${apiUrl}/api/getnet/cancel-sale`, { agent: AGENT }, {
        timeout,
        headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
};

export const closeBatch = async (apiUrl, timeout = 120000) => {
    const response = await axios.post(`${apiUrl}/api/getnet/close`, { agent: AGENT }, {
        timeout,
        headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
};

const GetnetService = { getStatus, cancelSale, closeBatch };
export default GetnetService;
